module.exports = __webpack_public_path__ + "img/37.a749ce15.jpg";